export const UNDEFINED_ROUTE = '*';
export const ROOT_ROUTE = '/';
export const PROJECTS_ROUTE = '/projects';
export const PROJECT_ROUTE = '/project/:projectId?/node/:nodeId?';
export const TEST_ROUTE = '/test';
export const LOGIN_ROUTE = '/login';
export const NOT_FOUND = '/404';
